import Box from "ds/components/Box";
import Typography from "ds/components/Typography";
import Timestamp from "components/Timestamp";

import { CellComponentProps } from "../types";

type ApiKeysListItemLastUsedCellProps = CellComponentProps;

const ApiKeysListItemLastUsedCell = ({ apiKey }: ApiKeysListItemLastUsedCellProps) => {
  return (
    <Box fullWidth gap="large">
      {apiKey.lastUsedAt && <Timestamp variant="p-body3" timestamp={apiKey.lastUsedAt} />}
      {!apiKey.lastUsedAt && (
        <Typography tag="span" variant="p-body3">
          Never used
        </Typography>
      )}
    </Box>
  );
};

export default ApiKeysListItemLastUsedCell;